
export let fiMessages={

  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"Sähköposti",
  "password":"Salasana",
  "remember":"Muista minut",
  "forget":"Unohtuiko salasana?",
  "sign in":"Kirjaudu sisään",
  "login":"Login",
  "sign up now":"Rekisteröidy nyt",
  "apply":"Pyydä avaamaan tili",
  "contact us":"Yhteystiedot",
  "Privacy Policy":"Tietosuojaseloste",
  "Terms of Use":"Käyttöehdot",
  "copyright":"Copyright © 2017, Medtrum Technologies Inc. Kaikki oikeudet pidätetään.",

  "chooseLang":"Valitse maa tai kieli",
  "asia":"Aasia",
  "europe":"Eurooppa",
  "middleEast":"Middle East",

  "applyHcp":"Pyydä avaamaan terveydenhuollon ammattilaisen tili",
  "sign up":"Rekisteröidy",
  "Patient":"Potilas",
  "Caregiver":"Hoitaja",
  "Email":"Sähköposti",
  "Mobile":"Matkapuhelin",
  "Enter email":"Anna sähköpostiosoite",
  "Enter mobile":"Enter mobile number",
  "Verification":"Vahvistuskoodi",
  "Invitation":"Invitation code",
  "full name":"Anna koko nimi",
  "Enter pass":"Anna salasana",
  "org":"Laitos",
  "Register":"Register",
  "send":"Lähetä",
  "createAccount":"Create Account",
  "agree":"Olen lukenut Medtrumin tietosuojaselosteen ja käyttöehdot ja hyväksyn ne.",
  "privacy":"",
  "and" :"",
  "use":"",
  "errtip1-1":"Sinun on annettava kelvollinen sähköpostiosoite. Sitä käytetään Medtrum-käyttäjänimenäsi.",
  "errtip1-2":"",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Väärä vahvistuskoodi",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Väärä käyttäjänimi",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Anna laitoksesi.",

  "errp1":"Salasanassa täytyy olla vähintään kolmea seuraavista merkkityypeistä:isot kirjaimet, pienet kirjaimet, numerot ja erikoismerkit.",
  "errp2":"",
  "errp3":"Salasanan on oltava 6–20 merkkiä pitkä.",
  "errp4":"Salasana ei saa olla sama kuin käyttäjänimi.",
  "errp5":"Kolme peräkkäistä numeroa sisältävä salasana ei kelpaa (esim: 123, 321).",
  "errp6":"Kolme peräkkäistä kirjainta sisältävä salasana ei kelpaa (esim: abc, cba).",
  "errp7":"Salasanassa ei voi olla välilyöntejä.",


  "Find account":"Nouda salasana.",
  "Enter username":"Anna käyttäjänimesi.",
  "Next":"Seuraava",
  "Cancel":"Peruuta",
  "Back":"Takaisin",
  "Enter veri":"Enter verification code",
  "Verify notice":"Etsi sähköpostitse lähetetty vahvistuskoodi.",
  "Create new":"Luo uusi salasana",
  "Create new notice":"Luo uusi salasana. Salasanassa on oltava vähintään 6 merkkiä.",
  "New pass" :"Uusi salasana",
  "Completed":"Valmis",
  "Created":"Uusi salasana on luotu.",
  "Login Now":"Kirjaudu sisään",

  "Delete":"Poista",
  "New Patient":"New Patient",
  "Add Patient":"Lisää potilas",
  "Filter":"Suodatin",
  "Name":"Nimi",
  "Gender":"Sukupuoli",
  "Age":"Ikä",
  "Type":"Tyyppi",
  "Duration":"Kesto",
  "Connections":"Tilin luoja",
  "UploadTime":"Latausaika",
  "Year":"Vuosi",
  "Years":"Vuotta",
  "Month":"Kuukausi",
  "Month2":"Kuukausi",
  "Months":"months",
  "Invite":"Kutsu",
  "Invited":"Kutsuttu",
  "All":"Kaikki",
  "Female":"Nainen",
  "Male":"Mies",
  "Not Set":"Not Set",
  "Type 1":"Tyyppi 1",
  "Type 2":"Tyyppi 2",
  "Gestational":"Raskausdiabetes",
  "Prediabetes":"Esidiabetes",
  "LADA":"Tyyppi 1.5 LADA",
  "Apply":"Käytä",
  "disUn":"Diabetestyyppiä ei määritetty",
  "ageUn":"Ikää ei määritetty",
  "genUn":"Sukupuolta ei määritetty",
  "addP":"Lisää potilas",
  "newP":"Uusi potilas",
  "findP":"Etsi potilas",

  "GDRNF":"Määrittämätön",
  "GDRF":"Nainen",
  "GDRM":"Mies",
  "女":"Male",

  "DBTNF":"Määrittämätön",
  "DBT1":"Tyyppi 1",
  "DBT2":"Tyyppi 2",
  "DBTLADA":"Tyyppi 1.5 LADA",
  "DBTPRE":"Esidiabetes",
  "DBTGEST":"Raskausdiabetes",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"No selection",
  "unspecif":"Määrittämätön",
  "register":"Potilas",
  "hcp":"Vahvista",

  "BG":"VS",
  "CARB":"Hiilihydr.",
  "INS":"Pistos",
  "EXR":"Liikunta",
  "OTR":"Muu",
  "HBA1C":"HbA1c",
  "DOSE":"Annos",
  "URINEK":"Virtsan ketonipitoisuus",
  "HEL":"HEL",
  "OTR1":"Muu",
  "Loading":"Ladataan",

  "home":"Etusivu",
  "pID":"Potilastunnus",
  "fullName":"Koko nimi",
  "gender":"Sukupuoli",
  "height":"Pituus",
  "weight":"Paino",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Syntymäaika",
  "disType":"Diabetestyyppi",
  "disDate":"Taudin toteamispäivä",
  "Address":"Osoite",
  "Postcode":"Postinumero",
  "Inpatient":"Sairaalapotilas",
  "Yes":"Kyllä",
  "No":"Ei",
  "Pno":"Potilasnro",
  "Bno":"Vuodenro",
  "create":"Luo",
  "Telephone":"Puhelin",

  "enterU":"Anna käyttäjänimi (sähköposti)",
  "search":"Etsi",
  "noU":"Käyttäjänimi on pakollinen.",
  "searchR":"Hakutulokset",
  "uername":"Käyttäjänimi",
  "alias":"Alias",
  "remove":"Poista",
  "viewG":"Näytä käyrät",
  "sendR":"Lähetä pyyntö",
  "rSent":"Pyyntösi on lähetetty.",
  "cancelR":"Peruuta pyyntö",

  "VcodeTip1":"Etkö saanut sitä? Odota minuutin ajan ja yritä uudestaan.",
  "VcodeTip2":"Yritä uudestaan",
  "VcodeTip3":"Lähetimme juuri vahvistuskoodin ",
  "Entercode":"Anna koodi",
  "Getcode":"Tilaa koodi",

  "messages":"Viestit",
  "profile":"Profiili",
  "sign out":"Kirjaudu ulos",
  "changeP":"Vaihda salasana",
  "connection":"Yhteydet",

  "myP":"Oma profiili",
  "Portrait":"Profiilikuva",
  "Profession":"Ammatti",
  "DPRONF":"Määrittämätön",
  "DPROENDOCRIN":"Endokrinologi",
  "DPRODIABTRA":"Diabeteshoitaja",
  "DPRONURSE": "Sairaanhoitaja",
  "DPRODIATIT":"Ravitsemusterapeutti",
  "DPROOTR": "Muu terveydenhuollon ammattilainen",
  "Organization":"Laitos",
  "Bio":"Esittely",
  "save":"Tallenna",
  "oldPa":"Vanha salasana ",
  "newPa":"Uusi salasana",
  "RePa":"Anna salasana uudelleen",
  "forgetY":"Unohtuiko salasana?",
  "applyM":"Käytä",
  "oldErr":"Vanha salasana on väärä.",
  "EntTheSame":"Anna uusi salasana uudelleen.",
  "EnterOld":"Anna vanha salasana.",

  "pList":"Potilasluettelo",
  "connections":"Connections",
  "settings":"Asetukset",
  "monitor":"Seuranta",
  "graphs":"Raportit",
  "events":"Tapahtumat",
  "records":"Tallenteet",
  "qPrint":"Pikatulostus",

  "sensorIn":"Sensorin tiedot",
  "timeOfLaRead":"Sensorin viimeisimmän lukeman aika",
  "tranSn":"Lähettimen sarjanro",
  "status":"Tila",
  "sensorLife":"Sensorilla käyttöaikaa",
  "lastSenorRead":"Sensorin viimeisin lukema",
  "TranBattery":"Lähettimen akku",
  "sg":"SG",
  "alert":"Varoitus",
  "target":"Tavoite",
  "hypo":"Hypo",
  "sensorGlucose":"Sensorin glukoosi",
  "calib":"Kalibrointi",
  "newSen":"Uusi sensori",
  "warm":"Lämpenee",
  "InsulinPump":"Insuliinipumppu",
  "timeOfLaPump":"Pumpun viimeisimpien tietojen aika",
  "pumpSN":"Pumppuosan sarjanro",
  "ReserviorLife":"Säiliölaastarilla käyttöaikaa",
  "InsulinLeft":"Insuliinia jäljellä",
  "basal":"Perusinsuliini",
  "bolus":"Bolus",
  "totalBasal":"Perusinsuliinia vrk yhteensä",
  "lastBolus":"Viimeisin bolus",
  "activeInsulin":"Aktiivinen insuliini",
  "totalBolus":"Bolusinsuliinia vrk:ssa",
  "tampBasal":"Väliaik. perusannos",
  "normalBolus":"Normaali bolus",
  "extendBolus":"Pitkä bolus",
  "manualStop":"Manuaal. pys.",
  "autoStop":"Auto Suspend",
  "auto suspend":"Automaattinen pysäytys",
  "stop":"Annon pysäytys",
  "newPatch":"Uusi laastari",
  "tempBasal":"Väliaik. perusannos",
  "N":"N",
  "E":"E",
  "CN1":"CN",
  "CE":"CE",

  "staticSettings":"Raporttiasetukset",
  "dataSource":"Tarkasteltavat tiedot",
  "unit":"Yksikkö",
  "glucoseTarget":"Glukoositavoitteen vaihteluväli",
  "overall":"Yht.",
  "Hypoglycemia":"Hypoglykemia",
  "timePeriod":"Ajanjakso",
  "postMeal":"Aterianjälkeinen analyysi",
  "Breakfast":"Aamiainen",
  "Lunch":"Lounas",
  "Dinner":"Päivällinen",
  "night":"Yöllä",
  "Before":"Ennen",
  "After":"Jälkeen",
  "Low":"Matala",
  "High":"Korkea",
  "From":"Alku",
  "To":"Loppu",
  "Hours":"Tuntia",
  "Reset":"Palauta oletusarvot",
  "RealTime":"Reaaliaikainen",
  "uploaded":"Ladattu",
  "sensor":"Sensori",
  "pdmSN":"PDM:n sarjanro",
  "startTime":"Aloitusaika",
  "endTime":"Lopetusaika",
  "uploadTime":"Latausaika",
  "pdm":"PDM",
  "Uploaded":"Ladattu",
  "Patch Pump":"Laastaripumppu",
  "overLapp":"Päällekkäiset käyttöajat",
  "showAlert":"Näytä varoitukset",

  "dashboard":"Dashboard",
  "dboard_glucose_statistics":"Glucose Statistics",
  "dboard_glucose":"Glucose",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insulin",
  "dboard_carbs":"Carbs",
  "dboard_exercise":"Exercise",
  "dboard_glucose_avg":"Average",
  "dboard_cgm_avg":"Average",
  "dboard_insulin_avg":"Average Daily Dose",
  "dboard_carbs_avg":"Average Carbs/Day",
  "dboard_exercise_avg":"Average time/Day",
  "dboard_sd":"SD",
  "dboard_num":"#",
  "dboard_num_days":"# days",
  "dboard_statistics":"Statistics",
  "dboard_BG":"BG",
  "dboard_BG_calibration":"BG / calibration (per day)",
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC high >",
  "dboard_AUC_low":"AUC low <",
  "dboard_highest_value":"Highest value",
  "dboard_lowest_value":"Lowest value",

  "dboard_pump":"Pump",
  "dboard_avg_daily_dose":"Average Daily Dose",
  "dboard_SD":"SD",
  "dboard_daily_basal":"Daily Basal",
  "dboard_daily_bolus":"Daily Bolus",
  "dboard_avg_bolus_num":"Average bolus no. per day",
  "dboard_avg_suspend_time":"Average Suspend time",
  "dboard_avg_reservoir_usage":"Average reservoir usage",
  "dboard_days":"days",

  "dboard_manual_bolus":"Manual bolus (volume/no. per day)",
  "dboard_normal":"-Normal",
  "dboard_extend":"-Extended",
  "dboard_combo":"-Combo",

  "dboard_bolus_calculator":"Bolus Calculator (volume/no. per day)",
  "dboard_food_bolus":"-Food bolus calc.",
  "dboard_corr_bolus":"-Corr bolus calc.",
  "dboard_override_add":"-Override(+)",
  "dboard_override_sub":"-Override(-)",

  "dboard_report":"Dashboard Report",

  "daily":"Päivittäinen yhteenveto",
  "date":"Pvm",
  "print":"Tulosta",
  "carbs":"Hiilihydr.",
  "exercise":"Liikunta",
  "heavy":"Rasitt.",
  "Medium":"Kohtal.",
  "Light":"Kevyt",
  "dailyReport":"Päivittäinen yhteenvetoraportti",
  "devices":"Laitteet",
  "tran":"Lähetin",
  "pumpBase":"Pumppuosa",
  "HbA1c":"HbA1c",
  "statics":"Tilastotiedot",
  "glucose":"Glukoosi",
  "item":"Kohde",
  "BG1":"VS",
  "SG1":"SG",
  "avgSD":"Keskiarvo (mmol/L)±SD",
  "avgSD1":"Keskiarvo±SD",
  "min":"Minimi",
  "max":"Maksimi",
  "ofRead":"Lukemien määrä",
  "ofHypo":"Hypogl. määrä/kesto",
  "ofAlert":"Varoitusten määrä",
  "insulin":"Insuliini",
  "insulin2":"Insuliini",
  "totalDose":"Vuorokauden kokonaisannos",
  "foodBolus":"Ateriabolus",
  "Food+coor":"Food+corr",
  "calibBolus":"Korjausbolus",
  "durationStop":"Keskeytyksen kesto (min)",
  "ofPumpAlert":"Pumpun hälytysten määrä",
  "ofMeal":"Aterioiden määrä",
  "totalExerTime":"Kokonaisliikunta-aika",
  "exerNum":"Liikuntaharjoitusten määrä",
  "avgInten":"Keskimääräinen rasittavuus",
  "target1":"Tavoite",
  "high1":"Korkea",
  "low1":"Matala",
  "BG Reading":"VS-lukemat",

  "dayByday":"Päiväkohtaiset yleistiedot",
  "dayBydayRe":"Päiväkohtaiset yleistiedot",
  "period":"Ajanjakso",

  "sensorOverlay":"Sensoripeittokuva",
  "set":"Aseta",
  "setPeriod":"Aseta ajanjakso",
  "Weekdays":"Arkipäivät",
  "Weekends":"Viikonloput",
  "Mon":"Ma",
  "Tue":"Ti",
  "Wed":"Ke",
  "Thur":"To",
  "Thu":"To",
  "Fri":"Pe",
  "Sat":"La",
  "Sun":"Su",
  "Average":"Keskiarvo",
  "sensorOlRe":"Sensorin peittokuvaraportti",
  "Avg":"Keskiarvo",
  "±SD":"±SD",
  "ofhypo":"Hypogl. määrä",
  "Everyday":"joka päivä",

  "TrendAna":"Trendianalyysi",
  "TrendRe":"Trendianalyysiraportti",
  "sensorGlu":"Sensorin glukoosi ",
  "ofBGtest":"# of BG tests",
  "Basics":"Perustiedot",
  "static":"Tilastotiedot",
  "Med":"Mediaani",
  "med":"median",
  "Q1":"Alakvartiili",
  "Q3":"Yläkvartiili",
  "Q11":"Alakvartiili",
  "Q31":"Yläkvartiili",
  "IQR":"Kvartiiliväli",
  "SD":"Keskihajonta",
  "CV":"Variaatiokerroin",
  "SE1":"Keskiarvon keskivirhe",
  "distri":"Jakauma",
  "stab":"Stabiilius",
  "#high":"Korkeiden määrä",
  "#low":"Matalien määrä",
  "aucBelow":"AUC-arvo alarajan alapuolella",
  "aucAbove":"AUC-arvo ylärajan yläpuolella",
  "bgRead":"VS-lukemat",
  "total":"Avg Daily Total",
  "avg_daily_basal":"Avg Daily Basal",
  "avg_daily_bolus":"Avg Daily Bolus",
  "ofBolus":"Boluksien määrä",
  "avgBolus":"Keskimääräinen bolus",
  "Dura1":"Kesto (min)",
  "Avg/Total":"Keskiarvo/yhteensä",
  "high":"Korkea",
  "low":"Matala",
  "#hypo":"Hypogl. määrä",
  "ofExer":"Liikuntaharjoitusten määrä",

  "logbook":"Lokikirja",
  "dailyTotal":"Vrk yhteensä",
  "High Glucose":"Korkea glukoosi",
  "Low Glucose":"Matala glukoosi",
  "No Active Patch":"Ei laastaria käytössä",
  "Missed Meal":"Ateria unohtui",
  "Multiple BG Readings":"Useat VS-lukemat",
  "Stop Patch":"Pysäytä laastari",
  "Others":"Others",
  "Other Events":"Muut tapahtumat",
  "logRe":"Lokikirjaraportti",

  "DeviceSetting":"Näytä laiteasetukset",
  "Insulin Pump":"Insuliinipumppu",
  "MaxBasalRate":"Maksimiperusannos",
  "BasalPatterns":"Perusannostelumallit",
  "Selected Basal Pattern":"Valittu perusannostelumalli",
  "Maximum Bolus":"Maksimibolus",
  "Combo/Extended Bolus":"Yhdistelmäbolus / pitkä bolus",
  "BG Reminder":"VS-muistutus",
  "Bolus Increment":"Boluksen erä",
  "Bolus Calculator":"Boluslaskuri",
  "Active Insulin Time":"Aktiivisen insuliinin aika",
  "IC Ratios":"IH-suhteet",
  "Insulin Sensitivity":"Insuliiniherkkyyskerroin",
  "BG Target":"VS-tavoite",
  "Bolus Reminder":"Bolusmuistutus",
  "CGM":"CGM",
  "CGM System":"CGM-järjestelmä",
  "Glucose Unit":"Glukoosin yksikkö",
  "Glucose Limits":"Glukoosirajat",
  "Predicitive Alerts":"Ennakoivat varoitukset",
  "Rate Alerts":"Nopeushälytykset",
  "type":"Tyyppi",
  "time":"Aika",
  "data":"Pvm",
  "Rate":"Rate",
  "Calibration Reminder":"Kalibrointimuistutus",
  "Calibration Repeat":"Kalibroinnin toisto",
  "Snooze":"Torkku",
  "Audio Options":"Ääniasetukset",
  "Confidence Reminder":"Kuittausmuistutus",
  "Backlight":"Taustavalo",
  "Sec":"s",
  "Alarm Clock":"Herätyskello",
  "Patch Expiration":"Laastarin vanhent.",
  "Sensor Expiration":"Sensorin vanhent.",
  "Hourly Max":"Tunnin maks.",
  "Daily Max":"Vrk:n maks.",
  "Low Reservoir":"Säiliö lähes tyhjä",
  "Low Suspend":"Alarajapysäytys",
  "Predictive Low Suspend":"Ennakoiva alarajapysäytys",
  "Rise":"Nousu",
  "Fall":"Lasku",
  "Auto Off":"Autom pys",
  "Standard":"Vakio",
  "Exercise":"Liikunta",
  "Holiday":"Loma",
  "ProgramA":"Malli A",
  "ProgramB":"Malli B",
  "--":"--",
  "Insulin":"Insuliini",

  "SUSA":"Autom pys",
  "SUSHM":"Yli 1 tunnin maksimin",
  "SUSDM":"Ylittää vuorokauden maksimin",
  "SUSLSG":"Alarajapysäytys",
  "SUSPLSG":"Ennakoiva alarajapysäytys",
  "Pump Restarted":"Pumppu käynnistetty uudelleen",
  "Meter BG Now":"Mittaa VS nyt",
  "Sensor Exp in 2 Hours":"Sensori vanhenee: 2 h",
  "Sensor Exp in 6 Hours":"Sensori vanhenee: 6 h",
  "Sensor Exp in 30 Min":"Sensori vanh.: 30 min",
  "Sensor Calibration Error":"Sensorin kalibr.virhe",
  "Sensor Error":"Sensorin virhe",

  "Device Settings Report":"Laiteasetusten raportti",
  "24h Total":"24 h yhteensä",
  "Device Settings at":"Laiteasetukset",
  "Start":"Alku",
  "Combo/Ext Bolus":"Yhd./pitkä bolus",
  "Time Format":"Kellonajan muoto",
  "Device Options（CGM System)":"Laiteasetukset (CGM-järjestelmä)",
  "Device Options（Insulin Pump)":"Laiteasetukset (insuliinipumppu)",
  "Dispay Settings (Screen)":"Näytön asetukset (näyttöruutu)",
  "Dispay Settings (Backlight)":"Näytön asetukset (taustavalo)",
  "Graph Range":"Käyräalue",
  "Range":"Range",
  "Repeat":"Toista",
  "Glucose Alerts":"Glukoosivaroit.",
  "Alert Silence":"Var. vaiennus",

  "Create":"Luo",
  "Event Filter":"Tapahtumasuodatin",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Virtsan ketonipitoisuus",
  "Injection":"Pistos",
  "Other":"Muu",
  "Event Type":"Tap.tyyppi",
  "Details":"Tiedot",
  "Notes":"Huomautukset",
  "Source":"Lähde",
  "edit":"Muokkaa",
  "Action":"Toimi",
  "EventReport":"Tapahtumien yhteenvetoraportti",
  "By Date":"Päivämäärän mukaan",
  "By Category":"Luokan mukaan",
  "Event Summary":"Tapahtumien yhteenveto",
  "No data":"Ei tietoja",
  "No1":"No",
  "data1":"data",
  "#":"Määrä",
  "BG Summary":"VS: yhteenveto",
  "Carbs Summary":"Hiilihydr.: yhteenveto",
  "Injection Summary":"Pistokset: yhteenveto",
  "Exercise Summary":"Liikunta: yhteenveto",
  "Input Notes":"Lisää huomautus",

  "Profile":"Profiili",
  "Complications":"Komplikaatiot",
  "Concomitant diseases":"Samanaikaiset sairaudet",
  "Suggestion":"Ehdotus",
  "Coronary heart disease":"Sepelvaltimotauti",
  "High blood lipids":"Veren suuri lipidipitoisuus",
  "High blood pressure":"Korkea verenpaine",
  "Kidney disease":"Munuaissairaus",
  "Neuropathy":"Neuropatia",
  "Obesity":"Lihavuus",
  "Peripheral arterial disease":"Perifeerinen valtimotauti",
  "Retinopathy":"Retinopatia",
  "Smoking addiction":"Tupakkariippuvuus",
  "Enter date":"Anna päivämäärä",
  "Enter suggestion":"Anna ehdotus",
  "Enter Notes":"Enter Notes",
  "Select":"Valitse",
  "Prescription":"Resepti",
  "Medicine":"Lääke",
  "Dose":"Annos",
  "Enter medicine":"Ilmoita lääke",
  "Enter dose":"Ilmoita annos",
  "Enterdis":"Enter concomitant diseases",
  "Add note":"Lisää huomautus",
  "Add Content":"Maksimipituus on 1 000 merkkiä.",
  "Other suggestions":"Muut ehdotukset",
  "OK":"OK",
  "HCP":"Terveydenhuollon ammattilainen",
  "Content":"Sisältö",
  "Records Report":"Tallenneraportti",

  "Quick Print":"Pikatulostus",
  "Quick Print Settings":"Pikatulostuksen asetukset",
  "Select duration":"Valitse kesto",
  "One Week":"Viikko",
  "One Month":"Kuukausi",
  "One Quarter":"Vuosineljännes",
  "End date":"Lopetuspäivä",
  "Yesterday":"Eilen",
  "Last Sunday":"Viime sunnuntai",
  "Last Saturday":"Viime lauantai",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Mukauta",
  "Week Filter":"Viikkosuodatin",
  "Select reports to print":"Valitse tulostettavat raportit",
  "Daily Summary":"Päivittäinen yhteenveto",
  "Day By Day Overview":"Päiväkohtaiset yleistiedot",
  "Sensor Overlay":"Sensoripeittokuva",
  "Trend Analysis":"Trendianalyysi",
  "Logbook":"Lokikirja",
  "Device Settings Review":"Näytä laiteasetukset",
  "createReport":"Luo raportti",

  "Segment Analysis":"Segmenttianalyysi",
  "Sensor Glucose Profile":"Sensorin glukoosiprofiili",
  "# of Boluses":"Boluksien määrä",
  "Bolus Insulin":"Bolusinsuliini",
  "Basal Pattern":"Perusannostelumalli",
  "Segment Analysis Report":"Segmenttianalyysiraportti",
  "Avg Glucose":"Keskimääräinen glukoosi",
  "Below":"Alle",
  "In Target Range":"Tavoitearvoalueella",
  "Coefficient of variation":"Variaatiokerroin",
  "% Time CGM Active":"Aika (%), kun CGM aktiivinen",
  "est_a1c_t1":"Estimated A1C:",
  "est_a1c_t2":"calculated from SG values",
  "est_a1c_t3":"Note: Estimated A1C does not replace lab measurement",

  "acceptTip":" on antanut sinulle luvan terveystietojensa etäkatseluun. ",
  "cancelTip":" on peruuttanut sinulle antamansa luvan terveystietojensa etäkatseluun. Voit pyytää lupaa tarvittaessa uudelleen.",
  "rejectTip":" on evännyt pyyntösi tietojen etäkatseluun.",
  "Read":"Lue",

  "Connection":"Yhteys",
  "connections1":"Yhteydet",
  "Add Connection":"Lisää yhteys",
  "SG":"SG",
  "Active Insulin":"Akt. insuliini",
  "Stop following":"Pysäytä seuranta",
  "Enter username (email)":"Anna käyttäjänimi (sähköposti)",
  "Search results":"Hakutulokset",
  "Send request":"Lähetä pyyntö",
  "View graphs":"Näytä käyrät",
  "Agree":"Hyväksy",
  "Deny":"Älä hyväksy",
  "Remove":"Poista",
  "Cancel Requset":"Peruuta pyyntö",
  "Remark":"Huomautus",

  "Warm up":"Lämpenee",
  "Monitoring":"Monitoring",
  "Transmitter Error":"Lähettimen virhe",
  "Sensor Failure":"Sensorin vika",
  "Sensor Expired":"Sensori vanhentunut",
  "Lost Sensor":"Sensori puuttuu",
  "Not Calibrated":"Ei kalibroitu",
  "Calibrating":"Kalibroidaan",
  "Calibration Needed":"Täytyy kalibroida",
  "Calibration Error":"Kalibrointivirhe",
  "Charging Battery":"Akkua ladataan",
  "Battery Charged":"Akku ladattu",

  "To be filled":"Pitää täyttää",
  "Filled with insulin":"Täytetty insuliinilla",
  "Priming":"Esitäyttö",
  "Priming completed":"Esitäyttö valmis",
  "Inserting needle":"Neulaa asetetaan paikalleen",
  "Patch activated":"Laastari otettu käyttöön",
  "Delivering Basal":"Annetaan perusinsuliinia",
  "Exceeds Max 1 Hour Delivery":"Yli 1 tunnin maksimin",
  "Exceeds Max TDD":"Ylittää vuorokauden maksimin",
  "Suspend":"Pysäytys",
  "Occlusion Detected":"Tukkeuma havaittu",
  "Patch Expired":"Laastari vanhentunut",
  "Empty Reservoir":"Tyhjä säiliö",
  "Patch Error":"Laastarin virhe",
  "Pump Base Error":"Pumppuosan virhe",
  "Patch Battery Depleted":"Laastarin paristo tyhjä",
  "Magnetic sensor not calibrated":"Magnetic sensor not calibrated",

  "Patient Profile":"Potilasprofiili",

  "On":"Kyllä",
  "on":"Kyllä",
  "Off":"Ei",
  "off":"Ei",

  "CORONARY_HEART_DISEASE":"Sepelvaltimotauti",
  "HIGH_BLOOD_LIPIDS":"Veren suuri lipidipitoisuus",
  "HIGH_BLOOD_PRESSURE":"Korkea verenpaine",
  "KIDNEY_DISEASE":"Munuaissairaus",
  "NEUROPATHY":"Neuropatia",
  "OBESITY":"Lihavuus",
  "PERIPHERAL_ARTERIAL_DISEASE":"Perifeerinen valtimotauti",
  "RETINOPATHY":"Retinopatia",
  "SMOKING_ADDICTION":"Tupakkariippuvuus",

  "saveTip":"Tallennus onnistui.",
  "changePaTip":"Salasana on vaihdettu.",
  "enterEmTip":"Anna sähköpostiosoitteesi.",
  "verErrTip":"Väärä vahvistuskoodi.",
  "chooseEventTip":"Valitse tulostettavat tapahtumat",
  "chooseDataTip":"Valitse tulostettavat tiedot",
  "dateWrongTip":"Lopetuspäivä ei saa olla ennen aloituspäivää.",
  "infoWrongTip":"Täytä kaikki pakolliset kentät.",
  "createdSuccssTip":"Luonti onnistui",
  "selectData":"Valitse tallennettavat tiedot",

  "acceSu":"Yhteyspyyntö hyväksytty",
  "acceEr":"Uuden yhteyden lisäys epäonnistui",
  "rejeSu":"Yhteyspyyntö evätty",
  "rejeEr":"Pyynnön epäys epäonnistui",

  "userNotExist":"Käyttäjänimeä ei ole.",
  "Password incorrect":"Väärä salasana.",
  "UserType incorrect":"Väärä käyttäjätyyppi",

  "registSuccess":"Tilin luonti onnistui.",
  "registFailed":"Uuden tilin rekisteröinti epäonnistui.",
  "sentSuccess":"Viestin lähetys onnistui",
  "sentFailed":"Viestin lähetys epäonnistui",
  "Input error":"Syöttövirhe",

  "deletePtip":"Haluatko varmasti poistaa nämä potilaat?",
  "deleteEvents":"Haluatko varmasti poistaa nämä tapahtumat?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Haluatko varmasti poistaa?",
  "confirm":"Vahvista",
  "deleteSuccess":"Poisto onnistui",
  "deleteFailed":"Kohteen poisto epäonnistui",
  "modifySuccess":"Vaihto onnistui",
  "modifyFailed":"Vaihto epäonnistui",
  "createSuccess":"Created successfully",
  "createFailed":"Create failed",
  "editSuccess":"Muokkaus onnistui",
  "editFailed":"Muokkaus epäonnistui",
  "Time overlapped":"Valitsemasi käyttöajat olivat päällekkäisiä.",

  "stopFollow":"Haluatko varmasti lopettaa tämän potilaan seuraamisen?",
  "CancelTip1":"Haluatko varmasti poistaa tämän yhteyden?",

  "Warning":"Varoitus",
  "agreeConnect":"Jos hyväksyt yhdistämispyynnön klikkaamalla ”Hyväksy”, terveystietosi ovat luettavissa uuden yhteyden kautta.",
  "denyConnect":"Haluatko varmasti evätä tämän yhteyspyynnön?",
  "deleteConnect":"Haluatko varmasti poistaa tämän yhteyden? Jos poistat sen, terveystietojasi ei voi enää lukea yhteyden kautta.",

  "Choose the events to print":"Valitse tulostettavat tapahtumat",
  "tryAgain":"Yritä uudestaan",
  "username and password is required":"username and password is required",
  "A name is required":"Nimi on pakollinen.",
  "username is required":"Käyttäjänimi on pakollinen.",
  "The date choose wrong":"Valittu päivä on väärä",
  "Date no more than 14 days":"Valinta ei saa ylittää 14 vuorokautta.",

  "CancelTip":"Haluatko varmasti poistaa tämän yhteyden?",
  "removeConnect":"Poisto onnistui",

  "dateErr1":"Valinta ei saa ylittää 90 vuorokautta.",
  "dateErr2":"Lopetuspäivä ei saa olla ennen aloituspäivää.",

  "Not Filled":"Määrittämätön",
  "Today":"Tänään",
  "duration":"Kesto",
  "interval":"Interval",
  "7 days":"7 päivää",
  "14 days":"14 päivää",
  "30 days":"30 days",
  "90 days":"90 days",
  "g":"g",

  "Sound+Vibrate":"Ääni ja värinä",
  "Sound":"Ääni",
  "Vibrate":"Värinä",
  "Silent":"Ei saa häiritä",
  "1":"Kerran",
  "2":"Päivittäin",
  "noMes":"Viestejä ei ole.",
  "noConnect":"Yhteyksiä ei ole.",
  "Customize":"Mukauta",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Jan",
  "Feb":"Feb",
  "Mar":"Mar",
  "Apr":"Apr",
  "May":"May",
  "Jun":"Jun",
  "Jul":"Jul",
  "Aug":"Aug",
  "Sep":"Sep",
  "Oct":"Oct",
  "Nov":"Nov",
  "Dec":"Dec",
  "ApplyTip":" request to view your data.",
  "noReadings":"Ei lukemia",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Uploaded Data",
  "daop_uploaded_data_text":"The data is from EasyTouch App or EasyView iPad App.",
  "daop_realtime_data":"Real-time Data",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(U)",
  "ins_unit2":"U",
  "basal_unit":"(U/H)",
  "basal_unit2":"U/H",

  // 告警
  "Alerts_Patch_Battery_Low":"Patch Battery Low",    // 0
  "Alerts_Patch_Battery_Depleted":"Patch Battery Depleted",
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Low Reservoir",
  "Alerts_Empty_Reservoir":"Empty Reservoir",
  "Alerts_Patch_Expiration_Advisory":"Patch Expiration Advisory",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Patch Expired",
  "Alerts_Patch_Error":"Patch Error",
  "Alerts_Pump_Base_Error":"Pump Base Error",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Occlusion Detected",
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Predictive Low Suspend",
  "Alerts_Low_Suspend":"Low Suspend",
  "Alerts_Auto_Off":"Auto Off",    // 19

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Lost Sensor",   // 100
  "Alerts_Transmitter_Battery_Low":"Transmitter Battery Low",
  "Alerts_Charge_Transmitter":"Charge Transmitter",
  "Alerts_Sensor_Error":"Sensor Error",
  "Alerts_Transmitter_Error":"Transmitter Error",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Sensor Failure",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Meter BG Now",
  "Alerts_Sensor_Exp_in_6_Hours":"Sensor Exp in 6 Hours",
  "Alerts_Sensor_Exp_in_2_Hours":"Sensor Exp in 2 Hours",
  "Alerts_Sensor_Exp_in_30_Min":"Sensor Exp in 30 Min",
  "Alerts_Sensor_Expired":"Sensor Expired",
  "Alerts_Rapid_Rise":"Rapid Rise",
  "Alerts_Rapid_Fall":"Rapid Fall",
  "Alerts_High_Predicted":"High Predicted",
  "Alerts_Low_Predicted":"Low Predicted",
  "Alerts_High_Glucose":"High Glucose",
  "Alerts_Low_Glucose":"Low Glucose",
  "Alerts_Below_3.1_mmol/L":"Below 3.1 mmol/L",  // 121
  "Alerts_Transmitter_Battery_Low_2":"Transmitter Battery Low",

  "Alerts_PDM_Battery_Low":"PDM Battery Low",
  "Alerts_Replace_Battery":"Replace Battery",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Alerts",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pump",
  //"CGM":"CGM",

  "Out Of Range": "Out Of Range",
}

//export default {fiMessages}



// WEBPACK FOOTER //
// ./src/lang/fi.js